<template>
  <div class="signin-wrapper">
    <div class="header">{{ $t(`${translationPath}.brandName`) }}</div>
    <img class="image-wrapper" src="@/assets/sign-in-image.svg">
    <div class="login-button" @click="logIn">{{ $t(`${translationPath}.loginIn`) }}</div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      translationPath: 'account',
    };
  },
  methods: {
    ...mapActions({
      setLoginModalDisplay: 'userStore/setLoginModalDisplay',
    }),
    logIn() {
      this.setLoginModalDisplay(true);
    },
  },
};
</script>

<style scoped lang='scss'>
.signin-wrapper {
  width: 100%;
  text-align: center;
}
.image-wrapper {
  margin: 50px auto;
  width: 80%;
}
.header {
  padding-top: 70px;
  font-weight: 800;
  font-size: 2.62rem;
  margin: 0 auto;
  text-align: center;
}
.login-button {
  font-weight: 700;
  text-align: center;
  margin-top: 25px;
  padding: 15px 25px;
  border-radius: 25px;
  background: $background-brand-color;
  color: $font-light-color;
  width: 250px;
  margin: 0 auto;
  cursor: pointer;
}
</style>
